module.exports = __webpack_public_path__ + "static/media/product_image_2.ad02d0aa.png";